import { EditorTools } from "./index221.js";
import { BuildingFloorLines } from "./index226.js";
import { RotatingEnvironment } from "./index241.js";
import { useReflectiveMaterial } from "./index242.js";
import { AbstractViewFC, DetailedViewFC } from "@project-rouge/rg-three";
import { Suspense, memo } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
const FeWorldEditor = memo(({ abstract, visibility, layers, readonly, floorLines, obj, skyUrl, ...editorToolProps }) => {
	useReflectiveMaterial(layers);
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!!skyUrl && /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(RotatingEnvironment, { url: skyUrl }) }),
		floorLines && /* @__PURE__ */ jsx(BuildingFloorLines, { obj }),
		abstract && /* @__PURE__ */ jsx(AbstractViewFC, { obj }),
		!abstract && /* @__PURE__ */ jsx(DetailedViewFC, {
			obj,
			visibility,
			layers
		}),
		!readonly && /* @__PURE__ */ jsx(EditorTools, {
			obj,
			visibility,
			...editorToolProps
		})
	] });
});
FeWorldEditor.displayName = "FeWorldEditor";
export { FeWorldEditor };

//# sourceMappingURL=index243.js.map